export const organizationalSkillsPerspective = [
  'teamBuilding',
  'talentDevelopment',
  'culturalAtmosphere'
]

export const personalDevelopmentPerspective = [
  'professionalPrecipitation',
  'abilityBreakthrough'
]

export const organizationalSkillsPerspectiveSelfReview = [
  'teamBuildingSelfReview',
  'talentDevelopmentSelfReview',
  'culturalAtmosphereSelfReview'
]

export const personalDevelopmentPerspectiveSelfReview = [
  'professionalPrecipitationSelfReview',
  'abilityBreakthroughSelfReview'
]
